import UsersProfile from './containers/UsersProfile';
import { Role, RouteConfig } from '../../types';

const AllRoles = Object.values(Role);

const routes: RouteConfig[] = [
  {
    key: 'profile',
    path: '/profile',
    title: 'DCA Profile',
    component: UsersProfile,
    roles: AllRoles,
  },
];

export default routes;
